
import React, { useState, Fragment } from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { get, has } from 'lodash';

// Storybook reference: https://ui-standard.hackhub.com/?path=/story/event-styleguide-checkboxes--checkboxes

const CheckboxWrapper = styled.div`
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 24px;
  color: #344054;
`;

const LabelessCheckboxWrapper = styled(CheckboxWrapper)`
  width: 20px;
  height: 20px;
  display: inline;
`;

const InputWrapper = styled.input`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0.2em;
    opacity: 0;
    width: 20px;
    height: 20px;
    z-index: 3;
`;

const Label = styled.label`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    height: 24px;
    position: absolute;
    top: 0;
    left: 30px;
    display: inline-block;
    width: auto;
`;

const Checkmark = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0.2em;
  width: 20px;
  height: 20px;
  border: ${(props) => (props.isChecked ? '1px solid #0094FB' : '1px solid #D0D5DD')};
  border-radius: 6px;
  background: ${(props) => (props.isChecked ? '#E6F5FF' : '#fff')};
  border-radius: 6px;
  cursor:pointer;

  ${CheckboxWrapper}:hover &{
    border: 1px solid #0094FB;
  }
`;

const CheckmarkIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0.6em;
  height: 20px;
  width: 20px;
  color: #0094FB;
  z-index: 2;
`;

export const Checkbox = ({
  field,
  form: { setFieldValue, values },
  otherProps
}) => {
  const [isChecked, setIsChecked] = useState(has(values, `${field.name}`) && typeof get(values, `${field.name}`) === 'boolean' ? get(values, `${field.name}`) : false);

  const handleCheck = () => {
    setIsChecked(!isChecked);
    setFieldValue(field.name, !isChecked);
  };

  const label = otherProps.label || '';

  if (label.length > 0) {
    return (
      <CheckboxWrapper>
        <Label>{label}</Label>
        <InputWrapper
          type='checkbox'
          checked={isChecked}
          onChange={handleCheck}
        />
        <Fragment>
          <Checkmark isChecked={isChecked} />
          {isChecked && <CheckmarkIcon name='checkmark' size='small' />}
        </Fragment>
      </CheckboxWrapper>
    );
  }

  return (
    <LabelessCheckboxWrapper>
      <InputWrapper
        type='checkbox'
        checked={isChecked}
        onChange={handleCheck}
      />
      <Fragment>
        <Checkmark isChecked={isChecked} />
        {isChecked && <CheckmarkIcon name='checkmark' size='small' />}
      </Fragment>
    </LabelessCheckboxWrapper>
  );
};


Checkbox.defaultProps = {
  isPrimary: true
};



// WEBPACK FOOTER //
// ./src/uiStandard/event/checkbox.js